import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/customer-groups/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/customer-groups`, config),
    fetchAll: (config: AxiosRequestConfig) =>
        api.get(`/customer-groups/all`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/customer-groups/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/customer-groups`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/customer-groups/${url.id}`, data, config),
};

export default requests;
